<template>
  <div
    class="fixed-action-bar"
    :class="{ 'fixed-action-bar--pending': !settled }"
  >
    <slot />
  </div>
</template>
<script>
export default {
  name: "FixedActionBar",
  props: {
    // false の間は中身を隠す。右側の操作の出し入れで中央のボタンが動き、誤クリックするのを防ぐ。
    settled: { type: Boolean, default: true }
  }
};
</script>
<style lang="scss" scoped>
.fixed-action-bar {
  position: relative;
  width: 100%;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 12px 16px;
  min-height: 64px; /* 各画面のサイドバー高さ計算(calc(100vh - ...))が参照する固定値 */
  border-top: 1px solid #e0e0e0;
  background-color: #fff;
}

// 枠と高さは保ったまま中身だけ隠す（サイドバーの高さ計算に影響させない）。
.fixed-action-bar--pending > :deep(*) {
  visibility: hidden;
}
</style>
